import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import { sendMessage } from '../helpers'

import { loadHistoryRequest } from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/HistoryContent/actions'
import { LOAD_HISTORY_REQUEST } from '../../../scenes/Gnosus/components/EntityStack/components/StackContent/components/HistoryContent/constants'
import { REFRESH_ENTITY_STACK_HISTORY } from './constants'
import { SOCKET_ON_MESSAGE, SOCKET_ACTION_TYPE } from '../constants'

function* onMessageFromOld(_action) {
    const type = _.get(_action, 'data.type', null)

    if (type === REFRESH_ENTITY_STACK_HISTORY) {
        yield put(loadHistoryRequest())
    }

    return null
}

function* wsRefreshHistoryCallSaga() {
    yield sendMessage(SOCKET_ACTION_TYPE.REFRESH_ENTITY_STACK_HISTORY, {})

    return null
}

export default function* entityStackHistorySaga() {
    yield all([
        takeEvery(SOCKET_ON_MESSAGE, onMessageFromOld),
        takeEvery(LOAD_HISTORY_REQUEST, wsRefreshHistoryCallSaga),
    ])
}
